export default __webpack_public_path__ + "static/media/personalFlotation.ab28c37e.png";